var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormInfoPage", {
                attrs: {
                  data: _vm.infoPage,
                  infoCategories: _vm.infoCategories,
                  loading: _vm.isMutationLoading,
                  loadingData: _vm.isFormLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formInfoPageSubmit,
                  "delete-info-page": _vm.deleteInfoPage,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:contentForMobile": function ($event) {
                    return _vm.changeContentForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmInfoPageRemove",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }